module.exports = __webpack_public_path__ + "img/faming5.032cf092.png";